import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf8f19e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "エンジン管理", -1))
const _hoisted_3 = { class: "dialog-form-area engine-list" }
const _hoisted_4 = {
  key: 0,
  class: "engine"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "engine-name" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_USIEngineOptionDialog = _resolveComponent("USIEngineOptionDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("dialog", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.engines.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " エンジンが登録されていません。 "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engines, (engine) => {
            return (_openBlock(), _createElementBlock("div", {
              key: engine.uri,
              class: "engine",
              value: engine.uri
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(engine.name), 1),
              _createElementVNode("button", {
                class: "dialog-button",
                onClick: ($event: any) => (_ctx.openOptions(engine.uri))
              }, " 設定 ", 8, _hoisted_7),
              _createElementVNode("button", {
                class: "dialog-button",
                onClick: ($event: any) => (_ctx.remove(engine.uri))
              }, " 削除 ", 8, _hoisted_8)
            ], 8, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "dialog-wide-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add()))
        }, "追加"),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "dialog-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAndClose()))
          }, " 保存して閉じる "),
          _createElementVNode("button", {
            class: "dialog-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
          }, "キャンセル")
        ])
      ], 512)
    ]),
    (_ctx.optionDialog)
      ? (_openBlock(), _createBlock(_component_USIEngineOptionDialog, {
          key: 0,
          "latest-engine-setting": _ctx.optionDialog,
          onOk: _ctx.optionOk,
          onCancel: _ctx.optionCancel
        }, null, 8, ["latest-engine-setting", "onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}